import React, { useEffect } from 'react'
import { Link, withRouter } from 'react-router-dom'
import MetisMenu from "metismenujs"
import '../../assets/fonts/font-awesome/font-awesome.css'
import { isMobile } from 'react-device-detect'
import { connect } from "react-redux"

const Sidebar = (props) => {
    const role = props.profile?.role?.codeName
    const pathname = props.location?.pathname || ''
    const search = props.location?.search || ''

    useEffect(() => {
        const menu = new MetisMenu("#side-menu", { toggle: false })
        return () => menu?.dispose?.()
    }, [role])

    useEffect(() => {
        const menu = document.getElementById("side-menu")
        const links = Array.from(menu.querySelectorAll('a:not(.has-arrow)'))
        links.forEach(link => {
            link.classList.remove('active')
            link.parentElement.classList.remove('mm-active')
        })

        // Prefer the most specific destination so product resources and creation
        // routes do not activate the generic product list.
        const matchingLink = links
            .filter(link => {
                const matchesPath = pathname === link.pathname || pathname.startsWith(`${link.pathname}/`)
                const currentParams = new URLSearchParams(search)
                const matchesSearch = Array.from(new URLSearchParams(link.search))
                    .every(([key, value]) => currentParams.get(key) === value)
                return matchesPath && matchesSearch
            })
            .sort((a, b) => b.pathname.length - a.pathname.length)[0]

        if (!matchingLink) return
        matchingLink.classList.add('active')
        matchingLink.parentElement.classList.add('mm-active')

        const submenu = matchingLink.closest('.site-menu-submenu')
        if (submenu) {
            submenu.classList.add('mm-show')
            const group = submenu.parentElement
            group.classList.add('mm-active')
            const trigger = group.querySelector('.has-arrow')
            trigger.classList.remove('mm-collapsed')
            trigger.setAttribute('aria-expanded', 'true')
        }
    }, [pathname, search, role])

    const toggleMenu = () => {
        if (isMobile) {
            props.toggleMenuCallback()
        }
    }

    return (
        <div id="sidebar" className="sidebar">
            <div className="site-menubar">
                <div className="site-menubar-header">
                    <Link to='/'>
                        <img alt="Canvas Express" src="/assets/images/logo.png" />
                    </Link>
                </div>

                <div className="site-menubar-body">
                    <ul className="metismenu list-unstyled site-menu" id="side-menu">
                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/dashboard"
                                    onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to Dashboard')
                                    }}>
                                    <i className="site-menu-icon bx bx-chart" aria-hidden="true"></i>
                                    <span className="site-menu-title">Dashboard</span>
                                </Link>
                            </li>
                        )}

                        <li className="site-menu-item">
                            <Link to="/#" className="has-arrow waves-effect" onClick={() => {
                                window.analytics.track('Open orders')
                            }}>
                                <i className="site-menu-icon mdi mdi-note"></i>
                                <span className="site-menu-title">Pedidos</span>
                            </Link>

                            <ul className="site-menu-submenu sub-menu">
                                <li><Link to='/sales-order' onClick={() => {
                                    toggleMenu()
                                    window.analytics.track('Go to sales orders')
                                }}>Pedidos <i className='mdi mdi-chevron-right'></i> </Link></li>
                            </ul>
                        </li>

                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/#" className="has-arrow waves-effect" onClick={() => {
                                    window.analytics.track('Open suppliers')
                                }}>
                                    <i className="site-menu-icon mdi mdi-handshake"></i>
                                    <span className="site-menu-title">Clientes</span>
                                </Link>

                                <ul className="site-menu-submenu sub-menu">
                                    <li><Link to='/customers' onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to customers list')
                                    }}>Clientes <i className='mdi mdi-chevron-right'></i></Link></li>
                                </ul>
                            </li>
                        )}

                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="site-menu-icon mdi mdi-barcode"></i>
                                    <span className="site-menu-title">Catálogo</span>
                                </Link>

                                <ul className="site-menu-submenu sub-menu">
                                    <li><Link to="/products" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to prodycts list')
                                    }}>Productos <i className='mdi mdi-chevron-right'></i></Link></li>
                                    <li><Link to='/products/add' onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to add product')
                                    }}>Nuevo producto <i className='mdi mdi-plus'></i> </Link></li>
                                    <li><Link to="/categories" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to categories list')
                                    }}>Categorías</Link></li>
                                    <li><Link to="/subcategories" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to subcategories list')
                                    }}>Subcategorías</Link></li>
                                    <li><Link to="/brands" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to brands list')
                                    }}>Marcas</Link></li>
                                </ul>
                            </li>
                        )}
                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="site-menu-icon mdi mdi-cog"></i>
                                    <span className="site-menu-title">Producción</span>
                                </Link>

                                <ul className="site-menu-submenu sub-menu">
                                    <li><Link to="/materials" onClick={toggleMenu}>Materiales</Link></li>
                                    <li><Link to="/frames" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to frames')
                                    }}>Marcos</Link></li>
                                    <li><Link to="/marialuisas" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to marialuisas')
                                    }}>María Luisas</Link></li>
                                    <li><Link to="/products/bulk?tab=pricing" onClick={toggleMenu}>Precios y envíos</Link></li>
                                </ul>
                            </li>
                        )}
                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="site-menu-icon mdi mdi-image"></i>
                                    <span className="site-menu-title">Recursos visuales</span>
                                </Link>

                                <ul className="site-menu-submenu sub-menu">
                                    <li><Link to="/products/sample-images" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to product sample images')
                                    }}>Imágenes utilitarias</Link></li>
                                    <li><Link to="/personalization-mockups" onClick={toggleMenu}>Mockups de personalizados</Link></li>
                                </ul>
                            </li>
                        )}
                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="site-menu-icon mdi mdi-bullhorn"></i>
                                    <span className="site-menu-title">Marketing</span>
                                </Link>

                                <ul className="site-menu-submenu sub-menu">
                                    <li><Link to="/hero-slides" onClick={toggleMenu}>Hero de portada</Link></li>
                                    <li><Link to="/discounts" onClick={() => {
                                        toggleMenu()
                                        window.analytics.track('Go to discounts')
                                    }}>Descuentos y cupones</Link></li>
                                </ul>
                            </li>
                        )}
                        {props.profile?.role?.codeName === 'ADMIN' && (
                            <li className="site-menu-item">
                                <Link to="/users" onClick={toggleMenu}>
                                    <i className="site-menu-icon mdi mdi-account-group"></i>
                                    <span className="site-menu-title">Usuarios</span>
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}

const mapStatetoProps = (state) => {
    return {
        profile: state.Auth.profile
    }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Sidebar))
